module.exports = __webpack_public_path__ + "img/triangle3red.8d0ccc1f.png";